/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to submit Automatic AD job." |
*
* @param {Ad_Job_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_failed = /** @type {((inputs?: Ad_Job_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de la soumission de la tâche AD automatique.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatischer AD-Auftrag konnte nicht übermittelt werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile inviare il processo AD automatico.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось отправить задание автоматической отправки в Active Directory.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo enviar la tarea automática de AD.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动 AD 作业提交失败。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動ADジョブの送信に失敗しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित AD जॉब सबमिट करने में विफल।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao enviar a tarefa automática do AD.")
	return /** @type {LocalizedString} */ ("Failed to submit Automatic AD job.")
});